export enum SonicFeature {
  FullStory = 'isFullStoryEnabled',
  ContentInsight = 'isContentInsightEnabled',
  StudioAccess = 'isStudioAccessEnabled',
  ContentVisualization = 'isContentVisualizationEnabled',
  GeneralRights = 'isGeneralRightsEnabled',
  Genres = 'isGenresEnabled',
  Images = 'isImagesEnabled',
  IMSForContentRatings = 'isIMSForContentRatingsEnabled',
  IMSForContentDescriptors = 'isIMSForContentDescriptorsEnabled',
  IMSForGenres = 'isIMSForGenresEnabled',
  IMSForLivestreams = 'isIMSForLivestreamsEnabled',
  IMSForTaxonomyNodes = 'isIMSForTaxonomyNodesEnabled',
  IMSForVideoAssets = 'isIMSForVideoAssetsEnabled',
  ListableAndPlayableAppNames = 'isListableAndPlayableAppNamesEnabled',
  ListableAndPlayableTerritories = 'isListableAndPlayableTerritoriesEnabled',
  LiveVideos = 'isLiveVideosEnabled',
  LookerLinks = 'isLookerLinksEnabled',
  MediaDownload = 'isMediaDownloadEnabled',
  Offers = 'isOffersEnabled',
  OffersReadOnly = 'isOffersReadOnlyEnabled',
  OTP = 'isOTPEnabled',
  PersonalizedAIRecommendations = 'isPersonalizedAIRecommendationsEnabled',
  HopperRecommendations = 'isHopperRecommendationsEnabled',
  WatchAgainKind = 'isWatchAgainKindEnabled',
  Providers = 'isProvidersEnabled',
  RelatedSiteBuilderObjects = 'isRelatedSiteBuilderObjectsEnabled',
  SourceSystemId = 'isSourceSystemIdEnabled',
  Subtitles = 'isSubtitlesEnabled',
  Tags = 'isTagsEnabled',
  Taxonomies = 'isTaxonomiesEnabled',
  TaxonomiesDefaultValuesEditing = 'isTaxonomiesDefaultValuesEditingEnabled',
  ImagesFilteredByProductLine = 'isImagesFilteredByProductLineEnabled',
  VirtualChannels = 'isVirtualChannelsEnabled',
  TVListings = 'isTVListingsEnabled',
  UserCapabilitiesV1 = 'isUserCapabilitiesV1Enabled',
  UserCapabilitiesV2 = 'isUserCapabilitiesV2Enabled',
  CapabilitiesBolt = 'isCapabilitiesBoltEnabled',
  CapabilitiesLegacy = 'isCapabilitiesLegacyEnabled',
  VideoAssetUpload = 'isVideoAssetUploadEnabled',
  VMS = 'isVMSEnabled',
  Masquerade = 'isMasqueradeEnabled',
  MainTerritoryCodeAndBrandIdOnTermKinds = 'isMainTerritoryCodeAndBrandIdOnTermKindsEnabled',
  ContentProtection = 'isContentProtectionEnabled',
  DTCRARContracts = 'isDTCRARContractsEnabled',
  DTCRARProducts = 'isDTCRARProductsEnabled',
  SiteBuilderBolt = 'isSiteBuilderBoltEnabled',
  SiteBuilderLegacy = 'isSiteBuilderLegacyEnabled',
  PricePlanProvidersWhenOngoing = 'isPricePlanProvidersWhenOngoingEnabled',
  ProviderAndSKUWhenSAMIntegration = 'isProviderAndSKUWhenSAMIntegrationEnabled',
  MergedCollections = 'isMergedCollectionsEnabled',
  SubscriptionJourney = 'isSubscriptionJourneyEnabled',
  RolesPermissions = 'isRolesPermissionsEnabled',
  StudioGlobalExpansion = 'isStudioGlobalExpansionEnabled',
  Pinning = 'isPinningEnabled',
  CompassReranking = 'isCompassRerankingEnabled',
  HorizontalReranking = 'isHorizontalRerankingEnabled',
  PricePlanFilteringByBrand = 'isPricePlanFilteringByBrandEnabled',
  PricePlanSourceSystem = 'isPricePlanSourceSystemEnabled',
  PricePlanMarketingInfoCharacterLimit = 'isPricePlanMarketingInfoCharacterLimitEnabled',
  AudienceTargeting = 'isAudienceTargetingEnabled',
  AudienceTargetingFromCustomerSegments = 'isAudienceTargetingFromCustomerSegmentsEnabled',
  GauthPartners = 'isGauthPartnersEnabled',
  DetokenizePaymentMethod = 'isDetokenizePaymentMethodEnabled',
  PayPerViewLegacy = 'isPayPerViewLegacyEnabled',
  PayPerViewBolt = 'isPayPerViewBoltEnabled',
  BoltSubscriptionJourney = 'isBoltSubscriptionJourneyEnabled',
  TerminateReasonNorwayDenmark = 'isTerminateReasonNorwayDenmarkEnabled',
  UserCommunication = 'isUserCommunicationEnabled',
  Legal = 'isLegalEnabled',
  Ratings = 'isRatingsEnabled',
  Search = 'isSearchEnabled',
  LabsBolt = 'isLabsBoltEnabled',
  LabsLegacy = 'isLabsLegacyEnabled',
  Packages = 'isPackagesEnabled',
  ShowTypes = 'isShowTypesEnabled',
  PushPinReranking = 'isPushPinRerankingEnabled',
  PackagesInCapabilities = 'isPackagesInCapabilitiesEnabled',
  PartnerSubscriptions = 'isPartnerSubscriptionsEnabled',
  SearchAutoCollection = 'isSearchAutoCollectionEnabled',
  BoltCapabilities = 'isBoltCapabilitiesEnabled',
  SiteBuilderCollectionSecondaryTitle = 'isSiteBuilderCollectionSecondaryTitleEnabled',
  SiteBuilderMyList = 'isSiteBuilderMyListEnabled',
  SiteBuilderRecentlyViewed = 'isSiteBuilderRecentlyViewedEnabled',
  SiteBuilderRecommendedShows = 'isSiteBuilderRecommendedShowsEnabled',
  SiteBuilderShowsWithExpiringEpisodes = 'isSiteBuilderShowsWithExpiringEpisodesEnabled',
  SiteBuilderVideoScheduleHour = 'isSiteBuilderVideoScheduleHourEnabled',
  SiteBuilderVideoTabbedScheduleGrid = 'isSiteBuilderVideoTabbedScheduleGridEnabled',
  SiteBuilderHideKindSortOptions = 'isSiteBuilderHideKindSortOptionsEnabled',
  SiteBuilderKindDisabled = 'isSiteBuilderKindDisabled',
  SiteBuilderVideoListingDisabled = 'isSiteBuilderVideoListingDisabled',
  SiteBuilderContinueWatching = 'isSiteBuilderContinueWatchingEnabled',
  SiteBuilderLegacyContinueWatching = 'isSiteBuilderLegacyContinueWatchingEnabled',
  SiteBuilderFilterByTaxonomyNodes = 'isSiteBuilderFilterByTaxonomyNodesEnabled',
  PartnerLinkCta = 'isPartnerLinkCtaEnabled',
  CollectionPersonalization = 'isCollectionPersonalizationEnabled',
  PasswordResetCopyToClipboard = 'isPasswordResetCopyToClipboardEnabled',
  LegacyContentSearch = 'isLegacyContentSearch',
  Badging = 'isBadgingEnabled',
  Avatars = 'isAvatarsEnabled',
  TaxonomyUsedByTypeCVNames = 'isTaxonomyUsedByTypeCVNamesEnabled',
  M10nFeatures = 'isM10nFeaturesEnabled',
  UserRoleChangeConfirmation = 'isUserRoleChangeConfirmationEnabled',
  Hotjar = 'isHotjarEnabled',
  Posthog = 'isPostHogEnabled',
  isMicrosoftClarityEnabled = 'isMicrosoftClarityEnabled',
  GSM = 'isGSMEnabled',
  UserIdentity = 'isUserIdentityEnabled',
  Collaborators = 'isCollaboratorsEnabled',
  ContractWithSidebar = 'ContractWithSidebar',
  IAPParentPricePlan = 'isIAPParentPricePlanEnabled',
  Multiverse = 'isMultiverseEnabled',
  Plans = 'isPlansEnabled',
  ProductVariants = 'isProductVariantsEnabled',
  ProductVariantsV2 = 'isProductVariantsV2Enabled',
  Sites = 'isSitesEnabled',
  TerritoryHierarchyDefinition = 'isTerritoryHierarchyDefinitionEnabled',
  IsPrsEnabled = 'isPrsEnabled',
  UserDeviceInfo = 'isUserDeviceInfoEnabled',
  UserDownloadsInfo = 'isUserDownloadsEnabled',
  SiteBuilderFilterByAgeGroups = 'isSiteBuilderFilterByAgeGroupsEnabled',
  SiteBuilderFilterByRoutes = 'isSiteBuilderFilterByRoutesEnabled',
  SiteBuilderFilterByKind = 'isSiteBuilderFilterByKindEnabled',
  SiteBuilderFilterByBrand = 'isSiteBuilderFilterByBrandEnabled',
  SiteBuilderFilterByAudienceTargeting = 'isSiteBuilderFilterByAudienceTargetingEnabled',
  SiteBuilderExcludeTargetForAudiences = 'isSiteBuilderExcludeTargetForAudiencesEnabled',
  Diana = 'isDianaEnabled',
  StudioPayments = 'isStudioPaymentsEnabled',
  StudioPaymentsIAPTransactions = 'isStudioPaymentsIAPTransactionsEnabled',
  StudioRolesWarning = 'isStudioRolesWarningEnabled',
  AddonProducts = 'isAddonProductsEnabled',
  TestSubscriptions = 'isTestSubscriptionsEnabled',
  MonetizationLegacy = 'isMonetizationLegacyEnabled',
  MonetizationBolt = 'isMonetizationBoltEnabled',
  MVPDDefederation = 'isMVPDDefederationEnabled',
  Badges = 'isBadgesEnabled',
  Disclaimers = 'isDisclaimersEnabled',
  Disclosures = 'isDisclosuresEnabled',
  Advisories = 'isAdvisoriesEnabled',
  UpdateUserMigration = 'isUpdateUserMigrationEnabled',
  PartnerMapping = 'isPartnerMappingEnabled',
  StudioIdentity = 'isStudioIdentityEnabled',
  DedupeCheckboxes = 'isDedupeCheckboxesEnabled',
  SilhouetteProfile = 'isSilhouetteProfileEnabled',
  SilhouetteRawProfiles = 'isSilhouetteRawProfilesEnabled',
  ProfileSimulator = 'isProfileSimulatorEnabled',
  UserAuthProviders = 'isUserAuthProvidersEnabled',
  ElvisLegalFeatureFlag = 'isElvisLegalFeatureEnabled',
  Flash = 'isFlashEnabled',
  $AppName = 'is$AppNameEnabled',
  VerticalPinning = 'isVerticalPinningEnabled',
  AuthProviderVerification = 'isAuthProviderVerificationEnabled',
  Mosaic = 'isMosaicEnabled',
  SiteReporting = 'isSiteReportingEnabled',
  Communications = 'isCommunicationsEnabled',
  StudioExperience = 'isStudioExperienceEnabled',
  Users = 'isUsersEnabled',
  BulkRefund = 'isBulkRefundEnabled',
  ExtraMemberHub = 'isExtraMemberHubEnabled',
  GeoOverrides = 'isGeoOverridesEnabled',
  PlanBulkActions = 'isPlanBulkActionsEnabled',
  IpWhitelist = 'isIpWhitelistEnabled',
  Multiconfig = 'isMulticonfigEnabled',
  LanguagesFromMultiConfig = 'isLanguagesFromMultiConfigEnabled',
  PlatformsFromMultiConfig = 'isPlatformsFromMultiConfigEnabled',
  ContentRestrictionsFromMultiConfig = 'isContentRestrictionsFromMultiConfigEnabled',
  AppNamesHardcoded = 'isAppNamesHardcoded',
  ProductLinesHardcoded = 'isProductLinesHardcoded',
  BrandsHardcoded = 'isBrandsHardcoded',
  PublishingSitesHardcoded = 'isPublishingSitesHardcoded',
  ContentSubsets = 'isContentSubsetsEnabled',
  PartnerPortal = 'isPartnerPortalEnabled',
  PartnerPortalExtendedCreateForm = 'isPartnerPortalExtendedCreateFormEnabled',
  UserPreferences = 'isUserPreferencesEnabled',
  UserSubscriptionsBolt = 'isUserSubscriptionsBoltEnabled',
  PersonalizedOffers = 'isPersonalizedOffersEnabled',
  Gprp = 'isGprpEnabled',
  MarketingPageCopy = 'isMarketingPageCopyEnabled',
  EnforceUserPasswordReset = 'isEnforceUserPasswordResetEnabled',
  StudioSupportTeamsManagement = 'isStudioSupportTeamsManagementEnabled',
  ServiceCatalog = 'isServiceCatalogEnabled',
  StudioSandbox = 'isStudioSandboxEnabled',
  TerritoriesFromMultiConfig = 'isTerritoriesFromMultiConfigEnabled',
  TerritoryGroupsFromMultiConfig = 'isTerritoryGroupsFromMultiConfigEnabled',
  LocalizedFieldSettingsFromLocalizationRead = 'isLocalizedFieldSettingsFromLocalizationReadEnabled',
  Localizations = 'isLocalizationsEnabled',
  BoltLocalization = 'isBoltLocalizationEnabled',
  LocalizationReporting = 'isLocalizationReportingEnabled',
  LocalizationBulkUpload = 'isLocalizationBulkUploadEnabled',
  LocalizedImages = 'isLocalizedImagesEnabled',
  LocalizedImagesAppExperience = 'isLocalizedImagesAppExperienceEnabled',
  MarketingPageExperiments = 'isMarketingPageExperimentsEnabled',
  MultiMarketCampaigns = 'isMultiMarketCampaignsEnabled',
  StudioStorage = 'isStudioStorageEnabled',
  PersonalizationSandbox = 'isPersonalizationSandboxEnabled',
  StudioTeams = 'isStudioTeamsEnabled',
  StudioChatBot = 'isStudioChatBotEnabled',
  StudioQuery = 'isStudioQueryEnabled',
  Messaging = 'isMessagingEnabled',
  CxGateway = 'isCxGatewayEnabled',
  CardBinUserSearch = 'isCardBinUserSearchEnabled',
  SNOWRequests = 'isSNOWRequestsEnabled',
  CapabilityValidator = 'isCapabilityValidatorEnabled',
  StaticLocalizations = 'isStaticLocalizationsEnabled',
  Bookmarks = 'isBookmarksEnabled',
  Announcements = 'isAnnouncementsEnabled',
  CxTooling = 'isCxToolingEnabled',
  Speed = 'isSpeedEnabled',
  ShadowSessions = 'isShadowSessionsEnabled',
  LinkedBadgesAndLegalLocalizations = 'isLinkedBadgesAndLegalLocalizationsEnabled',
  BlockEmailDomain = 'isBlockEmailDomainEnabled',
  AuditLogBeta = 'isAuditLogBetaEnabled',
  // 🚨 DON'T REMOVE COMMENT : Register your new feature above
}
